import ReactPixel from 'react-facebook-pixel';
import {Config} from '~/config';
import {ENV_DEV} from '~/config/constants';

export const fb = {
    inited: false,
    init: (email = undefined) => {
        if (!Config.params.FB || fb.inited) {
            return;
        }
        // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
        const advancedMatching = email ? { em: email } : {};
        const options = {
            autoConfig: true,
            debug: (process.env.NODE_ENV === ENV_DEV),
        };
        ReactPixel.init(Config.params.FB, advancedMatching, options);
        fb.pageView();
        fb.inited = true;
    },
    pageView: () => {
        if (!Config.params.FB) {
            return;
        }
        ReactPixel.pageView();
    },
    event: (name, payload = {}) => {
        if (!Config.params.FB) {
            return;
        }
        ReactPixel.track(name, payload);
    },
    registrationDone: () => {
        fb.event('Contact');
    },
    firstPayment: () => {
        fb.event('CompleteRegistration');
    }
}
